/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgUser = {
  header: 'Todos os usuários ({{count}})',
  disabled: '(desativado)',
  uid: 'Email',
  active: 'Estado',
  name: 'Nome',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  email: 'Email',
  orgUnit: 'Unidade',
  unit: 'Unidade',
  roles: 'Papéis',
  rights: 'Direitos',
  title: 'Título',
  hint: 'Os usuários são os compradores, aprovadores, gerentes e administradores da organização. Cada usuário recebe uma função para fazer ou aprovar compras. Cada usuário pertence a uma unidade e tem acesso a todas as unidades secundárias de sua unidade primária.',

  unitApprover: `Unidade aprobadora`,
  assignApprover: 'Adicionar o usuário aos aprovadores da unidade',

  actions: '',

  sortBy: 'Classificar por',
  sort: {
    byName: 'Nome',
    byUnit: 'Unidade',
  },

  details: {
    title: 'Detalhes do usuário',
    subtitle: 'Usuário: {{item.name}}',
  },
  edit: {
    title: 'Editar usuário',
    subtitle: 'Usuário: {{ item.name }}',
  },
  create: {
    title: 'Criar usuário',
    subtitle: '',
  },

  links: {
    password: 'Alterar senha',
    approvers: 'Aprovadores',
    userGroup: 'Grupos de usuários',
    permission: 'Limites de compra',
    rolesAndRights: 'Papéis y Direitos',
  },

  messages: {
    deactivateTitle: 'Disable este usuário?',
    deactivate:
      'Usuários com deficiência não podem fazer login na loja e fazer pedidos.',
    confirmEnabled:
      'Usuário {{item.firstName}} {{item.lastName}} habilitado com sucesso',
    confirmDisabled:
      'Usuário {{item.firstName}} {{item.lastName}} desabilitado com sucesso',
    update: 'Usuário {{item.firstName}} {{item.lastName}} atualizado com sucesso',
    create: 'Usuário {{item.firstName}} {{item.lastName}} criado com sucesso',
    updatePassword:
      'Senha do usuário {{item.firstName}} {{item.lastName}} atualizada com sucesso',
  },
  info: {
    disabledEdit: 'Permita que o usuário permita a edição.',
    disabledEnable: 'A unidade deve ser habilitada antes que esse usuário possa ser habilitado.',
  },

  approver: {
    link: 'Aprovadores',
    header: 'Aprovadores in {{code}}',
    assign: 'Alocação',
    assignHeader: 'Alocação in {{code}}',
    back: 'Atrás',
    new: 'Novo aprovador',
    instructions: {
      check: "Para atribuir um aprovador a esse usuário, marque a caixa de seleção do usuário.",
      uncheck: "Para remover um aprovador, desmarque a caixa de seleção do usuário.",
      changes: 'As alterações são salvas automaticamente.',
    },
  },

  userGroup: {
    link: 'Grupos de usuários',
    header: 'Grupos de usuários in {{code}}',
    assign: 'Atribuir grupos de usuários',
    assignHeader: 'Atribuir grupos de usuários in {{code}}',
    back: 'Atrás',
    instructions: {
      check:
        "Para atribuir um grupo de usuários a esse usuário, marque a caixa de seleção do usuário.",
      uncheck: "Para excluir um grupo de usuários, desmarque a caixa de seleção do usuário.",
      changes: 'As alterações são salvas automaticamente.',
    },
  },

  permission: {
    link: 'Limites de compra',
    header: 'Limites de compra in {{code}}',
    assign: 'Atribuir limites de compra',
    assignHeader: 'Atribuir limites de compra in {{code}}',
    back: 'Atrás',
    instructions: {
      check: 'Para atribuir um limite de compra a esse usuário, marque a caixa de seleção dele.',
      uncheck: 'Para cancelar a atribuição de um limite de compra, desmarque sua caixa de seleção.',
      changes: 'As alterações são salvas automaticamente.',
    },
    per: {
      undefined: '',
      MONTH: 'por mês',
      YEAR: 'por ano',
      WEEK: 'por semana',
      QUARTER: 'por trimestre',
    },
  },

  password: {
    title: 'Alterar senha',
    subtitle: 'Usuário: {{}}',
    newPassword: 'Nova senha',
    confirmPassword: 'Digite novamente a nova senha',
  },

  breadcrumbs: {
    list: 'Todos os usuários',
    details: '{{name}}',
    userGroups: 'Grupos de usuários',
    approvers: 'Aprovadores',
    permissions: 'Limites de compra',
  },
};

export const orgUserAssignedApprovers = {
  title: 'Aprovadores atribuídos',
  subtitle: 'Usuário: {{ item.name }}',
  assigned: 'Aprovador {{ item.name }} Atribuído corretamente',
  unassigned: 'Aprovador {{ item.name }} não atribuído corretamente',
};
export const orgUserApprovers = {
  title: 'Gerenciando aprovadores',
  subtitle: 'Usuário: {{ item.name }}',
  assigned: 'Aprovador {{ item.name }} Atribuído corretamente',
  unassigned: 'Aprovador {{ item.name }} não atribuído corretamente',
};

export const orgUserAssignedPermissions = {
  title: 'Limites de compra atribuídos',
  subtitle: 'Usuário: {{ item.name }}',
  assigned: 'Limite de compra {{ item.code }} atribuído com sucesso',
  unassigned: 'Limite de compra {{ item.code }} corretamente não alocado',
};

export const orgUserPermissions = {
  title: 'Gerenciar limites de compra',
  subtitle: 'Usuário: {{ item.name }}',
  assigned: 'Limite de compra {{ item.code }} atribuído com sucesso',
  unassigned: 'Limite de compra {{ item.code }} corretamente não alocado',
};

export const orgUserAssignedUserGroups = {
  title: 'Grupos de usuários asignados',
  subtitle: 'Usuário: {{ item.name }}',
  assigned: 'Grupo de usuários {{ item.name }} atribuído corretamente',
  unassigned: 'Grupo de usuários {{item.name}} não atribuído corretamente',
};

export const orgUserUserGroups = {
  title: 'Gerenciar grupos de usuários',
  subtitle: 'Usuário: {{ item.name }}',
  assigned: 'Grupo de usuários {{ item.name }} atribuído corretamente',
  unassigned: 'Grupo de usuários {{ item.name }} não atribuído corretamente',
};
